import { call, put, takeEvery } from "redux-saga/effects"

import {
  CREATE_FEATURES_FLAG,
  GET_FEATURES_FLAGS,
  ENABLE_FEATURES_FLAG,
  DISABLE_FEATURES_FLAG,
  TOGGLE_FEATURES_FLAGS_ACCOUNTS,
  TOGGLE_FEATURES_FLAGS_ADMIN_USERS,
  GET_WHITELISTED_BRANDS_FEATURE_FLAGS,
  CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS,
  DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS
} from "./actionTypes"

import {
  getFeaturesFlagsSuccess,
  getFeaturesFlagsError,
  createFeaturesFlagSuccess,
  createFeaturesFlagError,
  enableFeaturesFlagError,
  enableFeaturesFlagSuccess,
  disableFeaturesFlagError,
  disableFeaturesFlagSuccess,
  toggleFeaturesFLagsAccountsSuccess,
  toggleFeaturesFLagsAccountsError,
  toggleFeaturesFLagsAdminUsersSuccess,
  toggleFeaturesFLagsAdminUsersError,
  getWhitelistedBrandsFeatureFlagsSuccess,
  getWhitelistedBrandsFeatureFlagsError,
  createWhitelistedBrandsFeatureFlagsSuccess,
  createWhitelistedBrandsFeatureFlagsError,
  deleteWhitelistedBrandsFeatureFlagsSuccess,
  deleteWhitelistedBrandsFeatureFlagsError,
  getFeaturesFlags
} from "./actions"

import { genericGetRequestFeatures, genericPostRequestFeatures, genericDeleteRequestFeatures, genericGetRequest_2, genericPostRequest, genericDeleteRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"

function* onGetFeaturesFlags() {
  try {
    const response = yield call(
      genericGetRequestFeatures,
      `${AppConfiguration.BACKEND_URL}/flipper/api/features`,
      {}, // no query parameters
      {
      }
    )
    yield put(getFeaturesFlagsSuccess(response))
  } catch (error) {
    yield put(getFeaturesFlagsError(error))
  }
}

function* onCreateFeaturesFlags(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequestFeatures,
      `${AppConfiguration.BACKEND_URL}/flipper/api/features`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(createFeaturesFlagSuccess(response))
  } catch (error) {
    yield put(createFeaturesFlagError(error))
  }
}

function* onEnableFeaturesFlags(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequestFeatures,
      `${AppConfiguration.BACKEND_URL}/flipper/api/features/${action.payload.name}/boolean`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(enableFeaturesFlagSuccess(response))
  } catch (error) {
    yield put(enableFeaturesFlagError(error))
  }
}

function* onDisableFeaturesFlags(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericDeleteRequestFeatures,
      `${AppConfiguration.BACKEND_URL}/flipper/api/features/${action.payload.name}/boolean`,
      {
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(disableFeaturesFlagSuccess(response))
  } catch (error) {
    yield put(disableFeaturesFlagError(error))
  }
}

function* onToggleFeaturesFlagsAccounts(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequestFeatures,
      `${AppConfiguration.BACKEND_URL}/api/v1/toggle_feature_for_accounts`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(toggleFeaturesFLagsAccountsSuccess(response))
    yield put(getFeaturesFlags())

  } catch (error) {
    yield put(toggleFeaturesFLagsAccountsError(error))
  }
}

function* onToggleFeaturesFlagsAdminUsers(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequestFeatures,
      `${AppConfiguration.BACKEND_URL}/api/v1/toggle_feature_for_admin_users`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(toggleFeaturesFLagsAdminUsersSuccess(response))
    window.location.reload(); //TODO FIX THIS LATER
  } catch (error) {
    yield put(toggleFeaturesFLagsAdminUsersError(error))
  }
}

function* onGetWhitelistedBrandsFeatureFlags(action) {
  try {
    const whitelisted_brand_feature_flags = [];
    const admin_user = bsh_getAdminUserDetails();

    for (const brand of action.payload.whitelisted_brands_api_urls) {
      try {
        const response = yield call(
          genericGetRequest_2,
          `${brand.api_url}/api/v1/whitelabeled_brands_feature_flag/${action?.payload?.feature_key}`,
          { feature_key: action.payload.feature_key },
          {
            Authorization: admin_user.token,
            "is-master": 1,
            'Content-Type': 'application/json',
            "master-token": admin_user?.token
          }
        );
        whitelisted_brand_feature_flags.push({ ...response.data, ...brand });
      } catch (apiError) {
        continue;
      }
    }
    yield put(getWhitelistedBrandsFeatureFlagsSuccess(whitelisted_brand_feature_flags));
  } catch (error) {
    yield put(getWhitelistedBrandsFeatureFlagsError(error));
  }
}


function* onCreateWhitelistedBrandsFeatureFlags(action) {
  const whitelisted_brand_feature_flags = [];
  const admin_user = bsh_getAdminUserDetails();
  if (action?.payload?.status === "on") {
    try {
      const response = yield call(
        genericPostRequest,
        `${action.payload.api_url}/api/v1/whitelabeled_brands_feature_flag`,
        {
          body: JSON.stringify({
            ...action.payload,
          }),
          headers: {
            Authorization: admin_user.token,
            "is-master": 1,
            'Content-Type': 'application/json',
            "master-token": admin_user?.token
          }
        }
      )
      for (const key in action.payload.whitelisted_brand) {
        if (!response.hasOwnProperty(key)) {
          response[key] = action.payload.whitelisted_brand[key];
        }
      }
      yield put(createWhitelistedBrandsFeatureFlagsSuccess(response))
    } catch (error) {
      yield put(createWhitelistedBrandsFeatureFlagsError(error))
    }
  }
  else {
    try {
      for (const brand of action.payload.whitelisted_brands) {
        try {
          const response = yield call(
            genericPostRequest,
            `${brand.api_url}/api/v1/whitelabeled_brands_feature_flag`,
            {

              body: JSON.stringify({
                ...action.payload,
              }),
              headers: {
                Authorization: admin_user.token,
                "is-master": 1,
                'Content-Type': 'application/json',
                "master-token": admin_user?.token
              }
            }
          );
          whitelisted_brand_feature_flags.push(response);
        } catch (apiError) {
          continue;
        }
      }
      yield put(createWhitelistedBrandsFeatureFlagsSuccess(whitelisted_brand_feature_flags));
    }
    catch (err) {
      yield put(createWhitelistedBrandsFeatureFlagsError(err))
    }
  }
}

function* onDeleteWhitelistedBrandsFeatureFlags(action) {
  try {
    const admin_user = bsh_getAdminUserDetails();
    const response = yield call(
      genericDeleteRequest,
      `${action.payload.api_url}/api/v1/whitelabeled_brands_feature_flag/${action.payload.feature_key}`,
      {
        body: JSON.stringify({
          ...action.payload,
        }),
        headers: {
          Authorization: admin_user.token,
          "is-master": 1,
          'Content-Type': 'application/json',
          "master-token": admin_user?.token
        }
      }
    )
    for (const key in action.payload.whitelisted_brand) {
      if (!response.hasOwnProperty(key)) {
        response[key] = action.payload.whitelisted_brand[key];
      }
    }
    yield put(deleteWhitelistedBrandsFeatureFlagsSuccess(response))
  } catch (error) {
    yield put(deleteWhitelistedBrandsFeatureFlagsError(error))
  }
}

function* featuresFlagsSaga() {
  yield takeEvery(GET_FEATURES_FLAGS, onGetFeaturesFlags)
  yield takeEvery(CREATE_FEATURES_FLAG, onCreateFeaturesFlags)
  yield takeEvery(ENABLE_FEATURES_FLAG, onEnableFeaturesFlags)
  yield takeEvery(DISABLE_FEATURES_FLAG, onDisableFeaturesFlags)
  yield takeEvery(TOGGLE_FEATURES_FLAGS_ACCOUNTS, onToggleFeaturesFlagsAccounts)
  yield takeEvery(TOGGLE_FEATURES_FLAGS_ADMIN_USERS, onToggleFeaturesFlagsAdminUsers)
  yield takeEvery(GET_WHITELISTED_BRANDS_FEATURE_FLAGS, onGetWhitelistedBrandsFeatureFlags)
  yield takeEvery(CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS, onCreateWhitelistedBrandsFeatureFlags)
  yield takeEvery(DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS, onDeleteWhitelistedBrandsFeatureFlags)
}

export default featuresFlagsSaga;
